/**
 * Parses a value as a URL and returns its origin (scheme://host[:port]),
 * or an empty string when the value is not a valid absolute URL
 * (e.g. "", "https://" or a bare hostname).
 */
export const parseOrigin = (value: string): string => {
  try {
    return new URL(value).origin;
  } catch {
    return "";
  }
};
